/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {PureComponent} from 'react';
import Tooltip from "./Tooltip.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";

class CloseButton extends PureComponent {
    render() {
        let {size = "normal", className} = this.props

        let outerClassName = "pl-3 pr-3 h-7"
        let iconClassName = "h-5 w-5"

        switch (size) {
            case "sm":
                outerClassName = " h-5"
                iconClassName = "h-4 w-4"

        }


        return (

            <div className={`${outerClassName} flex items-center`} onClick={() => {
                if (this.props.onClick !== undefined) {
                    this.props.onClick()
                }
            }}>
                <Tooltip text={"Close"} delay={2000}
                         className={` rounded-md text-gray-300 hover:text-red-400 hover:bg-stone-200/60 p-2 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${className}`}
                >
                    <span className="sr-only">Close panel</span>
                    {/*<DisplayIcon iconName={"IoClose"} className={"h-5 w-5"} />*/}
                    <DisplayIcon iconName={"IoCloseOutline"} className={` ${iconClassName}`}/>

                </Tooltip>
            </div>

        );
    }
}

CloseButton.propTypes = {};

export default CloseButton;